module.exports = __webpack_public_path__ + "img/am.39c5d05e.svg";